


import { Filter, FilterRaw } from "../store";

interface TransformedFilters {
    [key: string]: {
        value: any | any[];
        relation?: string;
        relation2?: string;
        relationType?: 'is' | 'every' | 'some' | 'none';
        relationType2?: 'is' | 'every' | 'some' | 'none';
    };
}

// export const transformCheckDataToFilter = (filtersArray: Filter[]): TransformedFilters => {
//     return filtersArray.reduce((acc: TransformedFilters, filter: Filter) => {
//         const { nameColumn, value, nameTable, nameTable2 } = filter;

//         // Verifica si la columna ya existe y si tiene la misma relación
//         if (acc[nameColumn] && acc[nameColumn].relation === nameTable) {
//             // Si ya existe y es la misma relación, maneja el valor como array
//             if (!Array.isArray(acc[nameColumn].value)) {
//                 acc[nameColumn].value = [acc[nameColumn].value];
//             }
//             if (!(acc[nameColumn].value as any[]).includes(value)) {
//                 (acc[nameColumn].value as any[]).push(value);
//             }
//         } else {
//             // Si la columna no existe o tiene una relación diferente, crea o sobrescribe el filtro
//             acc[nameColumn] = {
//                 value: value,
//                 ...(nameTable !== nameColumn && { relation: nameTable }),
//                 ...(nameTable2 && { relation2: nameTable2 }) // Añade relation2 si nameTable2 está presente
//             };
//         }

//         return acc;
//     }, {});
// };




export const transformCheckDataToFilter = (filtersArray: FilterRaw[]): TransformedFilters => {
    return filtersArray.reduce((acc: TransformedFilters, filter: FilterRaw) => {
        const { nameColumn, value, nameTable, nameTable2, relationType, relationType2 } = filter;

        console.log("aqui entra relationType2????", relationType2)
        console.log("aqui entra relationType2????", relationType2)
        console.log("aqui entra relationType2????", relationType2)
        console.log("aqui entra relationType2????", relationType2)
        console.log("aqui entra relationType2????", relationType2)

        // Verifica si la columna ya existe y si tiene la misma relación
        if (acc[nameColumn] && acc[nameColumn].relation === nameTable) {
            // Si ya existe y es la misma relación, maneja el valor como array
            if (!Array.isArray(acc[nameColumn].value)) {
                acc[nameColumn].value = [acc[nameColumn].value];
            }
            if (!(acc[nameColumn].value as any[]).includes(value)) {
                (acc[nameColumn].value as any[]).push(value);
            }
        } else {
            // Si la columna no existe o tiene una relación diferente, crea o sobrescribe el filtro
            acc[nameColumn] = {
                value: value,
                ...(nameTable !== nameColumn && { relation: nameTable }),
                ...(nameTable2 && { relation2: nameTable2 }), // Añade relation2 si nameTable2 está presente
                ...(relationType && { relationType }),        // Añade relationType si está presente
                ...(relationType2 && { relationType2 }),      // Añade relationType2 si está presente
            };
        }

        return acc;
    }, {});
};
